import React, { useRef } from "react";
import Button from "components/common/Button";
import PopupModal, { PopupModalRef } from "components/common/PopupModal";
import ModalContent from "components/modals/ModalContent";
import BookingService from "services/booking";
import { useNotification } from "hooks/useNotification";
import { get } from "utils/lodash";
import { AlertTriangle } from "lucide-react";

interface CancelBookingProps {
  booking: any;
  onSuccess?: (res?: any) => void;
  onFail?: (error?: any) => void;
  className?: string;
}

export default function CancelBooking({
  className,
  booking,
  onSuccess,
  onFail,
}: CancelBookingProps) {
  const modalRef = useRef<PopupModalRef>(null);
  const [isLoading, setIsLoading] = React.useState(false);
  const notification = useNotification();
  const bookingId = get(booking, "id", "");

  const customerName = get(booking, "populatedUser[0].name") ||
                      get(booking, "user.name") ||
                      "khách hàng";

  const handleCancel = async () => {
    try {
      setIsLoading(true);
      const res = await BookingService.cancelBooking({ id: bookingId });
      notification.success("Hủy lịch thành công");
      modalRef.current?.close();
      onSuccess?.(res);
    } catch (error) {

      onFail?.(error);
      notification.error("Hủy lịch thất bại");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Button
        className={className}
        variant="secondary"
        size="sm"
        loading={isLoading}
        onClick={() => modalRef.current?.open()}
      >
        <span className="font-semibold">Hủy lịch</span>
      </Button>
      <PopupModal ref={modalRef}>
        <ModalContent
          content={
            <div className="flex flex-col items-center gap-4">
              <AlertTriangle className="w-12 h-12 text-yellow-500" />
              <label className="text-center">
                Bạn có chắc chắn muốn hủy lịch hẹn của{" "}
                <span className="font-semibold">{customerName}</span>?
              </label>
            </div>
          }
          closable
          cancelLabel="Không"
          acceptLabel="Có, hủy lịch"
          onAccept={handleCancel}
          onCancel={() => modalRef.current?.close()}
        />
      </PopupModal>
    </>
  );
}